import React, { useCallback, useEffect, useState } from "react";
import Editor from "../../../form/Editor";
import Select from "../../../form/select/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { useMutation, useQuery } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import { postAddEdit, postDetails } from "../../../../services/postService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Tags from "../../../form/Tags";
import SelectSingleImage from "../../../form/SelectSingleImage";
import SelectImageGallery from "../../../form/SelectImageGallery";
import Textarea from "../../../form/Textarea";
import LanguageTabs from "../../../elements/LanguageSwitcher";
import { generateSlug, supportedLanguages, userLang } from "../../../../helpers";
import FlexibleSelect from "../../../form/select/FlexibleSelect";

const validation = {
  title: { required: true, message: "Title is required" },
  content: { required: true, message: "Content is required" },
};

const ManageService = ({ getResponse = () => { }, close = () => { }, data = {} }) => {
  const [serviceImage, setServiceImage] = useState("");
  const [focusKeywords, setFocusKeywords] = useState([]);
  const [ogImage, setOgImage] = useState("");
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });
  const [currentLang, setCurrentLang] = useState(userLang || "en");
  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  const { data: details } = useQuery({
    queryKey: ["post-details", data?._id],
    queryFn: async () => {
      const res = await postDetails({ id: data?._id, slug: data?.slug, uid: data?.uid });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  console.log(details, "details");

  // useEffect(() => {
  //   if (details?._id) {
  //     setFieldsValue({
  //       title: details?.title,
  //       content: details?.content,
  //       visibility: details?.visibility,
  //     });
  //     setServiceImage(details?.featuredImage);
  //     setFocusKeywords(details?.seo?.focusKeyword?.map((item) => ({ label: item })));
  //     setOgImage(details?.seo?.ogImage);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [details]);

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        ...details,
        content: {
          ...supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = {
              title: details?.content?.[lang.code]?.title || "",
              subTitle: details?.content?.[lang.code]?.subTitle || "",
              content: details?.content?.[lang.code]?.content || "",
              seo: details?.content?.[lang.code]?.seo || {},
              visiblity: details?.content?.[lang.code]?.visibility || "",
            };
            return acc;
          }, {}),
        },
      });
      setServiceImage(details?.coverMedia);
      setFocusKeywords(details?.seo?.focusKeyword?.map((item) => ({ label: item })));
      setOgImage(details?.seo?.ogImage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        type: "service",
        slug: `${generateSlug(val?.content?.[userLang]?.title.replace(/\s+/g, "-").toLowerCase(), Date.now())}`,
        lang: localStorage.getItem("lang"),
        content: val?.content,
        visibility: values?.visibility,
        coverMedia: serviceImage?._id,
        seo: {
          focusKeyword: focusKeywords?.map((item) => item?.label),
          ogImage: ogImage?._id,
        },
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleKeywordChange = useCallback((val) => {
    setFocusKeywords(val);
  }, []);

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <LanguageTabs languages={supportedLanguages} value={currentLang} onChange={handleLangChange} />
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-6">
          <Input
            label="Title"
            inputType={"title"}
            inputPlaceholder="title"
            inputName={`content.${currentLang}.title`}
            value={values?.content?.[currentLang]?.title || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    title: newValue,
                  },
                },
              });
            }}
          />
        </div>
        <div className="relative col-span-6">
          <div className="border border-gray-300 rounded-lg p-4 space-y-2">
            <SelectSingleImage
              label="Upload Image"
              size="md"
              value={serviceImage}
              onChange={(img) => setServiceImage(img)}
              onRemove={() => setServiceImage(null)}
            />
          </div>
        </div>
        <div className="relative col-span-12">
          <Textarea
            label="Content"
            inputPlaceholder="Write Content"
            inputClasses="!h-28"
            inputName="content"
            inputValue={values?.content?.[currentLang]?.content || ""}
            // onChange={handleChange}
            // onChange={(val) => {
            //   setFieldsValue({
            //     ...values,
            //     content: {
            //       ...values.content,
            //       [currentLang]: {
            //         ...values.content?.[currentLang],
            //         content: val,
            //       },
            //     },
            //   });
            // }}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    content: newValue,
                  },
                },
              });
            }}
          />
        </div>
        <div className="relative col-span-12">
          <FlexibleSelect
            label={"Visibility"}
            placeholder="Select Visibility"
            selectedValue={values?.visibility}
            dropdownData={[
              { name: "Public", value: "public" },
              { name: "Private", value: "private" },
            ]}
            onChange={(val) => {
              handleChange({ target: { name: "visibility", value: val } });
            }}
            {...formValidate(errors, "visibility")}
          />
        </div>

        <div className="relative col-span-12 bg-white border border-primary rounded-md px-4 py-4">
          <div className="text-lg font-semibold text-slate-700   mb-1">SEO</div>
          <div className="grid grid-cols-12 gap-4 items-center bg-slate-50 border border-slate-100 px-4 py-4 mt-2 rounded-lg">
            <div className="relative col-span-12">
              <Tags
                selectedItems={focusKeywords}
                setSelectedItems={setFocusKeywords}
                onChange={handleKeywordChange}
                placeholder="Enter tags"
                dropdownEnabled={false}
              />
            </div>
            <div className="relative col-span-3">
              <div className="border border-gray-300 rounded-lg p-4 space-y-2">
                <SelectSingleImage
                  label="Upload Image"
                  size="md"
                  value={ogImage}
                  onChange={(img) => setOgImage(img)}
                  onRemove={() => setOgImage(null)}
                />
              </div>
              {/* <div className=" p-4 rounded-md border border-text-secondary/50">
                <SelectImageGallery
                  label="Choose Media"
                  values={ogImage}
                  onChange={(newMedia) => setOgImage(newMedia)}
                  isSingle={true}
                />
              </div> */}
              {/* <FileUploadSingle
                label={"Upload Image"}
                labelClasses={"!mb-2"}
                value={values?.ogImage}
                onChange={(file) => handleChange({ target: { name: "ogImage", value: file } })}
                {...formValidate(errors, "ogImage")}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="pt-3 p-6 flex justify-end">
          <Button
            buttonType="submit"
            buttonClasses={"min-w-36"}
            buttonLabel={details?._id ? "Update" : "Save"}
            {...((isLoading || detailsLoading) && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageService;
